export default __webpack_public_path__ + "static/media/Dmitri-Particle_0006_StompImpact.91dd3be3.png";